<div class="col-sm-12">

    <h3>Avaliar patrocínio</h3>
    <hr>

    <!-- =================================== ANEXOS===================================-->
    <p-dialog [style]="{width: '800px'}" header="{{nomeAnexo}}" [(visible)]="displayAnexo" showEffect="fade" [modal]="true"
    [baseZIndex]="10000">

    <div class="col-sm-12">
      <h3>Anexo</h3>
      <hr>
    </div> 

    <div class="col-sm-12 text-center">
      <hr>
      <div class="embed-container" *ngIf="viewDownload">
       
         <div class="myIframe">
            <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
         </div>

      </div>         
  
    </div>



  </p-dialog>
    <!--==============================================================================-->

    <div class="col-sm-12">       

        

   
                <div class="col-sm-12">
                            <h3 class="text-center">PROPOSTA</h3>
                    

                    <div class="col-sm-12">

                        <p>Tipo de processo:</p>
                        <h4 class="text-light-blue"><b>{{dispensaInexigibilidade.tipoProposta}}</b></h4>
                        <hr>
                        <p>Título e descrição:</p>
                        <div style="border: 1px solid #eee; margin-left: 12px; padding: 10px;">
                            <h4 class="text-light-blue"><b>{{ dispensaInexigibilidade.titulo }}</b></h4>
                            <hr>
                            <div [innerHtml]="dispensaInexigibilidade.descricao"></div>
                        </div>
                        <hr>
                        <p>Link dos Anexos</p>
                        <div *ngFor="let anexo of anexosSalvos">
                            <a style="cursor: pointer;" (click)="openModalAnexo(anexo, 'existente')"> Anexo: {{anexo.proposta}}</a>
                        </div>
                       
                        <hr>
                        <p>Justificativa / Orçamento / Entidade(s):</p>
                        <div style="border: 1px solid #eee; margin-left: 12px; padding: 10px;">
                            <div>
                                <h4 class="text-light-blue"><b>{{planoTrabalho.entidadeProponente.nome }}</b></h4>
                                <hr>
                                <p><b>Justificativa:</b></p>
                                <div [innerHtml]="planoTrabalho.justificativa"></div>
                                <hr>
                               
                                <p><b>Orçamento projeto:</b></p>
                                <dl class="dl-horizontal">
                                    <dt>Unidade orçamentária: </dt>
                                    <dd>{{ planoTrabalho.et2UnidadeOrcamentaria }}</dd>
                                    <dt>Fonte: </dt>
                                    <dd>{{ planoTrabalho.et2Fonte }}</dd>
                                    <dt>Dotação orçamentária: </dt>
                                    <dd>{{ planoTrabalho.et2DotacaoOrcamentaria }}</dd>
                                    <dt>Elemento despesa: </dt>
                                    <dd>{{ planoTrabalho.et2ElementoDespesa }}</dd>
                                    <dt>Valor: </dt>
                                    <dd>{{ planoTrabalho.et2Valor }}</dd>
                                    <dt>Valor por extenso: </dt>
                                    <dd>{{ planoTrabalho.et2ValorExtenso }}</dd>
                                </dl>
                            </div>
                                                  </div>

                    </div>
                 
                    <div class="col-sm-12">
                        <p class="text-center">AVALIAÇÃO</p>
                            <div class="col-sm-6">
                                <h4>Defina o situação da proposta</h4>
                                <div class="form-group">
                                    <div class="radio">
                                        <label>
                                            <input type="radio" name="optionsRadios" id="optionsRadios2"
                                               
                                               > Aprovado
                                        </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <label>
                                            <input type="radio" name="optionsRadios" id="optionsRadios3"
                                                > Reprovado
                                        </label>
                                    </div>
                                </div>
                                
                            </div>
                            
                            <div class="col-sm-6">
                                <h4>Justifique sua Avaliação</h4>
                                <p-editor placeholder="Justificativa">
                                </p-editor>
                            </div>
                            

                    </div>
                    
                    <div class="col-sm-6">
                        <div class="ui-g-10 ui-fluid" >
                        
                            <label>Ação:</label>
                            <p-select name="status" [options]="listaAcao"
                                placeholder="Selecione" [filter]="true" 
                                                                    
                                 required></p-select>
                        </div>
                    </div>
                    
                    <div class="col-sm-6">
                        <div class="ui-g-10 ui-fluid" >
                        
                            <label>Produto:</label>
                            <p-select name="status" [options]="listaProduto"
                                placeholder="Selecione" [filter]="true" 
                                                                     
                                 required></p-select>
                        </div>
                    </div>
                   
                    <div class="text-center" >
                        <a class="btn btn-primary btn-sm" (click)="voltarListagem()">Voltar a listagem</a>
                        <a class="btn btn-success btn-sm" (click)="salvar()">SALVAR AVALIAÇÃO</a>
                    </div>
                </div>
         

            
      

    </div>

</div>